// This avoids FE / BE decimal rounding error issues when applying coupon codes.
// On BE we use logic to ensure we don't pass Stripe values past 2 decimals.
// This ensures we can have accurate price between FE and BE
export const convertPriceTotalWithRounding = (totalPriceInMinorUnits: number, quantity: number) => {
  const result = totalPriceInMinorUnits / quantity;
  const resultWithFloor = Math.floor(result) * quantity;
  return { resultWithFloor };
};
